module.exports = __webpack_public_path__ + "static/DIVIV-35-8ec1e283353766462841c93fc98fb70c.jpg";